import { FC } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import authService from '../services/authService';


const ProtectedRoutes: FC = () => {
    const token = authService.getToken()

    return token ? <Outlet /> : <Navigate to="/login" />
}

export default ProtectedRoutes